import { Icon } from "@iconify/react/dist/iconify.js";
import { useState } from "react";
import { SURVEY_API_URL } from "../Constants/APIConstants";

// First-load survey modal. The survey itself (question, answers, and the path
// it renders on) is authored by a platform admin in the Scout/Analytics
// dashboard and fetched in Funker530.js; this component just renders the
// active survey and posts the chosen answer.

// Per-survey localStorage key so a newly activated survey shows even if the
// visitor already answered a previous one.
export function surveyStorageKey(surveyKey) {
  return `funker_survey_${surveyKey}`;
}

function markAnswered(surveyKey) {
  try {
    localStorage.setItem(surveyStorageKey(surveyKey), "1");
  } catch {
    // localStorage may be unavailable (private mode); fail silently.
  }
}

function SurveyModal({ survey, onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const surveyKey = survey.survey_key;
  const answers = survey.answers ?? [];

  function Dismiss() {
    markAnswered(surveyKey);
    onClose();
  }

  function StopPropagation(e) {
    e.stopPropagation();
  }

  function SubmitAnswer(answerKey) {
    // Fire-and-forget. text/plain keeps this a "simple" CORS request (no
    // preflight); the Scout endpoint parses the body as JSON regardless.
    try {
      fetch(SURVEY_API_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify({ survey_key: surveyKey, answer_key: answerKey }),
        keepalive: true,
      }).catch(() => {});
    } catch {
      // Ignore network errors — the response is best-effort/anonymous.
    }
    markAnswered(surveyKey);
    setSubmitted(true);
  }

  return (
    <div className="surveyModal">
      <div className="modalScreenMask" onClick={Dismiss}>
        <div className="modalContainer surveyContainer" onClick={StopPropagation}>
          <div className="close" onClick={Dismiss}>
            <Icon icon="ic:outline-close" className="closeButton" />
          </div>

          <img
            className="surveyLogo"
            src="/Funker_Premium_Logo.png"
            alt="Funker530 Veteran Community"
          />

          {submitted ? (
            <div className="surveyThanks">
              <Icon icon="ic:round-check-circle" className="surveyThanksIcon" />
              <div className="surveyThanksText">Thank you for your service.</div>
              <div className="surveyDone funkerButton" onClick={onClose}>
                Close
              </div>
            </div>
          ) : (
            <>
              <div className="surveyQuestion">{survey.question}</div>
              <div className="surveyAnswers">
                {answers.map((answer) => (
                  <div
                    key={answer.key}
                    className="surveyAnswer funkerButton"
                    onClick={() => SubmitAnswer(answer.key)}
                  >
                    {answer.label}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SurveyModal;
